import React from 'react';
import { observer,inject } from 'mobx-react';
import LoadingSpinner from '../LoadingSpinner';
import ButtonSpinner from '../ButtonSpinner';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Utils from '../../Utils';
import {  Button } from 'react-bootstrap';

@inject('userStore')
@observer
export default class UserList extends React.Component {
    componentDidMount(){
        this.props.userStore.GetUsers();
    }
    dateFormater(cell,row){
        return Utils.Dates.ToString("dd/mm/yyyy",cell);
    }
    editButtonFormatter(cell,row){
        return(<Button onClick={()=>{
            this.props.userStore.ShowOrHideAddUserModal(row.UID);
        }} >Edit</Button>);
    }
   
    resetButtonFormatter(cell,row){
        return(<Button onClick={()=>{
            this.props.userStore.UserIdToReset = row.UID;
            this.props.userStore.ResetPassword(row.Email);
        }} >Reset <ButtonSpinner key={"spnr-"+row.UID} IsLoading={this.props.userStore.SendingResetEmail && row.UID === this.props.userStore.UserIdToReset} /></Button>);
    }
   render(){
      if(!this.props.userStore.LoadingUsers){
        return(<BootstrapTable data={this.props.userStore.Users} striped={true} hover={true}>
        <TableHeaderColumn dataField="UID" isKey={true} hidden={true} autoValue={ true }>UID</TableHeaderColumn>
        <TableHeaderColumn dataField="FirstName" dataSort={true}>First Name</TableHeaderColumn>
        <TableHeaderColumn dataField="LastName" >Last Name</TableHeaderColumn>
        <TableHeaderColumn dataField="Email" >Email</TableHeaderColumn>
        <TableHeaderColumn dataField="Ext" >Ext</TableHeaderColumn>
        <TableHeaderColumn dataField="UserType" editable={ { type: 'select', options: { values: ["Admin","User"] } } } >Role</TableHeaderColumn>
        <TableHeaderColumn dataField="CreatedDate" autoValue={ true } dataFormat={this.dateFormater} >Created On</TableHeaderColumn>
        <TableHeaderColumn dataField="ModifiedDate" autoValue={ true } dataFormat={this.dateFormater} >Modified On</TableHeaderColumn>
        <TableHeaderColumn dataField="ModifiedDate" autoValue={ true } dataFormat={this.dateFormater} >Modified On</TableHeaderColumn>
        <TableHeaderColumn  dataFormat={this.editButtonFormatter.bind(this)} >Edit</TableHeaderColumn>
        <TableHeaderColumn  dataFormat={this.resetButtonFormatter.bind(this)} >Reset</TableHeaderColumn>
    </BootstrapTable>);
      }
      else{
        return(<LoadingSpinner/>);
      }
   }
}


// WEBPACK FOOTER //
// ./src/components/Users/UserList.js